
let URL;

// URL = 'http://72.60.206.123:2024/api/'
URL = 'https://api.thegearbox.in/api/'
// URL = 'http://localhost:2024/api/'

let apiPath = {

  baseURL: URL,
  dashboard: "admin/dashboard",
  location: "admin/dashboard/location",

  // Auth API
  logout: "admin/auth/logout",
  login: "admin/auth/login",

  profile: "admin/auth/get-profile",
  updateProfile: "admin/auth/update-profile",
  changePassword: "admin/auth/change-password",

  forgotPassword: "admin/auth/forgot-password",
  verifyOTP: "admin/auth/verify-otp",
  resetPassword: "admin/auth/reset-password",

  // Product APIs
  listProduct: "admin/product/list",
  addEditProduct: "admin/product/add-edit",
  editProduct: "admin/product/edit",
  statusProduct: "admin/product/status",
  viewProduct: "admin/product/view",
  importProduct: "admin/product/import",
  exportProduct: "admin/product/export",

  // Product Price PDF APIs
  listTempPDFs: "admin/product-price/list-temp",
  listLivePDFs: "admin/product-price/list-live",
  makePDFLive: "admin/product-price/make-live",
  makeAllPDFLive: "admin/product-price/make-all-live",

  // CMS APIs
  listCms: "admin/cms/list",
  addEditCms: "admin/cms/add-edit",
  statusCms: "admin/cms/status",
  viewCms: "admin/cms/view",

  // Subscription APIs
  listSubscription: "admin/subscription/list",
  addEditSubscription: "admin/subscription/add-edit",
  editSubscription: "admin/subscription/edit",
  statusSubscription: "admin/subscription/status",
  viewSubscription: "admin/subscription/view",

  // Vehicle Manufacturer APIs
  listVehicleManufacturer: "admin/vehicle-manufacturer/list",
  addEditVehicleManufacturer: "admin/vehicle-manufacturer/add-edit",
  statusVehicleManufacturer: "admin/vehicle-manufacturer/status",
  viewVehicleManufacturer: "admin/vehicle-manufacturer/view",

  // Vehicle APIs
  listVehicle: "admin/vehicle/list",
  addEditVehicle: "admin/vehicle/add-edit",
  statusVehicle: "admin/vehicle/status",
  viewVehicle: "admin/vehicle/view",

  // Feedback APIs
  listFeedback: "admin/feedback/list",
  viewFeedback: "admin/feedback/view",

  // Vehicle Model APIs
  listVehicleModel: "admin/vehicle-model/list",
  addEditVehicleModel: "admin/vehicle-model/add-edit",
  statusVehicleModel: "admin/vehicle-model/status",
  viewVehicleModel: "admin/vehicle-model/view",
  deleteVehicleModel: "admin/vehicle-model/delete",

  // Catalogue APIs
  listCatalogue: "admin/catalogue/list",
  addEditCatalogue: "admin/catalogue/add-edit",
  statusCatalogue: "admin/catalogue/status",
  viewCatalogue: "admin/catalogue/view",
  deleteCatalogue: "admin/catalogue/delete",

  // Content APIs
  listContent: "admin/content/list",
  addEditContent: "admin/content/add-edit",
  statusContent: "admin/content/status",
  viewContent: "admin/content/view",

  // Vehicle APIs
  listVehicle: "admin/vehicle/list",
  addEditVehicle: "admin/vehicle/add-edit",
  statusVehicle: "admin/vehicle/status",
  viewVehicle: "admin/vehicle/view",

  // City APIs
  listCity: "admin/city/list",
  addEditCity: "admin/city/add-edit",
  statusCity: "admin/city/status",
  viewCity: "admin/city/view",
  deleteCity: "admin/city/delete",

  // State APIs
  listState: "admin/state/list",
  addEditState: "admin/state/add-edit",
  statusState: "admin/state/status",
  viewState: "admin/state/view",
  deleteState: "admin/state/delete",

  // Segment APIs
  listSegment: "admin/segment/list",
  addEditSegment: "admin/segment/add-edit",
  statusSegment: "admin/segment/status",
  viewSegment: "admin/segment/view",
  deleteSegment: "admin/segment/delete",

  // User APIs
  listUser: "admin/user/list",
  spListUser: "admin/user/sp-list",
  addEditUser: "admin/user/add-edit",
  statusUser: "admin/user/status",
  viewUser: "admin/user/view",
  activityLogs: "admin/user/activity-logs",
  activityScreenNames: "admin/activity-log/screen-names",
  importFile: "admin/user/import-file",

  // Setting APIs
  addEditSetting: "admin/setting/add-edit",

  // Schemes APIs
  listSchemes: "admin/schemes/list",
  addEditSchemes: "admin/schemes/add-edit",
  statusSchemes: "admin/schemes/status",
  viewSchemes: "admin/schemes/view",
  deleteSchemes: "admin/schemes/delete",

  listCategory: "admin/category/list",
  addEditCategory: "admin/category/add-edit",
  viewCategory: "admin/category/view",
  statusCategory: "admin/category/status",
  deleteCategory: "admin/category/delete",

  listBrand: "admin/brand/list",
  addEditBrand: "admin/brand/add-edit",
  viewBrand: "admin/brand/view",
  statusBrand: "admin/brand/status",

  listSubCategory: "admin/sub-category/list",
  addEditSubCategory: "admin/sub-category/add-edit",
  viewSubCategory: "admin/sub-category/view",
  statusSubCategory: "admin/sub-category/status",
  deleteSubCategory: "admin/sub-category/delete",

  // Common Routes 
  commonSegment: "common/segment",
  commonTag: "common/tag",
  commonSubCategory: "common/sub-category",
  commonBrand: "common/brand",
  commonCategory: "common/category",
  commonCity: "common/city",
  commonVehicle: "common/vehicle",
  commonVehicleModel: "common/vehicle-model",
  commonState: "common/state",
  commonManufacturer: "common/vehicle-manufacturer",
  commonSetting: "common/setting",

};

export default apiPath;
